import { render, staticRenderFns } from "./Acceso.vue?vue&type=template&id=427ae856&scoped=true&"
import script from "./Acceso.vue?vue&type=script&lang=js&"
export * from "./Acceso.vue?vue&type=script&lang=js&"
import style0 from "./Acceso.vue?vue&type=style&index=0&id=427ae856&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427ae856",
  null
  
)

export default component.exports